app.controller('esEntityLookupDoctorController', ['$scope', 'doctorModel',
    function ($scope, doctorModel) {
        $scope.$on(Event.DOCTOR.GET_DATA_PAGE.SUCCESS, function (event, dataPage, code) {
            $scope.items = dataPage.data;
            $scope.lookupInProgress = false;
        });

        $scope.getData = function (s) {
            if(s) {
                var criteria = new PatientDataGridCriteria();
                criteria.searchPhrase = s;
                criteria.rowsPerSheet = 10;
                doctorModel.getDataPage(criteria);
                $scope.lookupInProgress = true;
            } else {
                $scope.items = [];
            }
        };

        $scope.getLabel = function(item) {
            if(item) {
                return item.getFullName();
            }
        };

    }
]);